/* eslint-disable react/prop-types */
import * as React from 'react';

import { translate } from '~l10n/client';

import CloseX from 'CloseX';
import platform from 'Platform';

export default class ModalView extends React.Component {
  render() {
    return (
      <div
        id="modal-wrapper"
        style={{
          width: this.props.modalWidth ? this.props.modalWidth : 700,
        }}
      >
        <div
          id="modal-holder"
          className={this.props.modalClass ? this.props.modalClass : ''}
        >
          <div
            className={
              platform.browser === 'IE'
                ? 'modal-header ie-browser'
                : 'modal-header'
            }
          >
            <h1 className="modal-title">{this.props.title}</h1>
            <a
              className="cancel-button"
              title={translate('Close')}
              onClick={(event) => {
                event.preventDefault();
                this.props.onCloseClicked();
              }}
            >
              <CloseX color="#ccc" />
            </a>
          </div>
          <div id="modal-content">{this.props.content}</div>
        </div>
      </div>
    );
  }
}
